import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useQuote } from '../context/QuoteContext';
import './Dashboard.css';

function StatusBadge({ status }) {
  return <span className={`status-badge ${status.toLowerCase()}`}>{status}</span>;
}

export default function Dashboard() {
  const { user } = useAuth();
  const { getQuotesByEmail, quotes } = useQuote();

  const myQuotes = user.role === 'admin' ? quotes : getQuotesByEmail(user.email);

  const stats = [
    { label: 'Total Quotes',   value: myQuotes.length,                                      icon: '📋' },
    { label: 'Pending',        value: myQuotes.filter(q => q.status === 'Pending').length,   icon: '⏳' },
    { label: 'In Review',      value: myQuotes.filter(q => q.status === 'In Review').length, icon: '🔍' },
    { label: 'Approved',       value: myQuotes.filter(q => q.status === 'Approved').length,  icon: '✅' },
  ];

  return (
    <div className="dashboard">
      <div className="container">
        {/* Header */}
        <div className="dash-header">
          <div>
            <h1>Welcome back, {user.name.split(' ')[0]} 👋</h1>
            <p className="dash-sub">{user.role === 'admin' ? 'Admin dashboard — manage all quotes and users.' : 'Your project dashboard — track your quote requests.'}</p>
          </div>
          <Link to="/get-quote" className="btn-grad">+ New Quote</Link>
        </div>

        {/* Stats */}
        <div className="dash-stats">
          {stats.map(s => (
            <div key={s.label} className="dash-stat-card">
              <div className="dsc-icon">{s.icon}</div>
              <div className="dsc-num">{s.value}</div>
              <div className="dsc-label">{s.label}</div>
            </div>
          ))}
        </div>

        {/* Quick links */}
        <div className="dash-quick">
          <h2>Quick actions</h2>
          <div className="quick-grid">
            <Link to="/get-quote"  className="quick-card"><div className="qc-icon" style={{ background:'#f3e8ff' }}>📋</div><div className="qc-text"><strong>New Quote</strong><span>Submit a project request</span></div></Link>
            <Link to="/services"   className="quick-card"><div className="qc-icon" style={{ background:'#ccfbf1' }}>🌐</div><div className="qc-text"><strong>Our Services</strong><span>Browse what we offer</span></div></Link>
            <Link to="/portfolio"  className="quick-card"><div className="qc-icon" style={{ background:'#dbeafe' }}>🏆</div><div className="qc-text"><strong>Portfolio</strong><span>View case studies</span></div></Link>
            <Link to="/contact"    className="quick-card"><div className="qc-icon" style={{ background:'#fce7f3' }}>💬</div><div className="qc-text"><strong>Contact Us</strong><span>Talk to our team</span></div></Link>
            {user.role === 'admin' && <Link to="/admin" className="quick-card"><div className="qc-icon" style={{ background:'#fef9c3' }}>⚙️</div><div className="qc-text"><strong>Admin Panel</strong><span>Manage all quotes</span></div></Link>}
            <Link to="/profile"    className="quick-card"><div className="qc-icon" style={{ background:'#f0f0eb' }}>👤</div><div className="qc-text"><strong>My Profile</strong><span>Update your info</span></div></Link>
          </div>
        </div>

        {/* Quotes table */}
        <div className="dash-section">
          <div className="dash-section-header">
            <h2>{user.role === 'admin' ? 'All Quotes' : 'My Quote Requests'}</h2>
            {user.role === 'admin' && <Link to="/admin" className="btn-out" style={{ fontSize: 13, padding: '8px 16px' }}>Manage all →</Link>}
          </div>

          {myQuotes.length === 0 ? (
            <div className="dash-empty">
              <div className="de-icon">📋</div>
              <h3>No quotes yet</h3>
              <p>Submit your first project request and we'll get back to you within 24 hours.</p>
              <Link to="/get-quote" className="btn-grad" style={{ marginTop: 16 }}>Get a free quote →</Link>
            </div>
          ) : (
            <div className="quotes-table-wrap">
              <table className="quotes-table">
                <thead>
                  <tr>
                    <th>Quote ID</th>
                    <th>Name</th>
                    <th>Service</th>
                    <th>Budget</th>
                    <th>Status</th>
                    <th>Submitted</th>
                  </tr>
                </thead>
                <tbody>
                  {myQuotes.map(q => (
                    <tr key={q.id}>
                      <td><code className="quote-id">{q.id}</code></td>
                      <td><div className="qt-name">{q.name}</div><div className="qt-email">{q.email}</div></td>
                      <td>{q.service}</td>
                      <td>{q.budget || '—'}</td>
                      <td><StatusBadge status={q.status} /></td>
                      <td>{new Date(q.submittedAt).toLocaleDateString('en-IN', { day:'2-digit', month:'short', year:'numeric' })}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
